import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadWeightLocationAftDto } from '../../api/models/HeadWeightLocationAftDto';

export type TABLE_TYPE = Table<HeadWeightLocationAftDto>;

export const TABLE = 'headWeightLocationAft';
const SCHEMA = 'headWeightLocationAftId';

class HeadWeightLocationAftDatabase implements DataRepository<HeadWeightLocationAftDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadWeightLocationAftDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadWeightLocationAftDto, key: Key): Promise<HeadWeightLocationAftDto> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadWeightLocationAftDto[]): Promise<HeadWeightLocationAftDto[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadWeightLocationAftDto[]> {
    return this.db[TABLE].toArray();
  }
}

export const HeadWeightLocationAftDB = new HeadWeightLocationAftDatabase(db);
